<template>
  <div
    class="h-footer-wrap"
    :class="[
      {
        type1: showType === 1,
        type2: showType === 2,
        'type1 type3': showType === 3,
        fromTG: isTgApp,
      },
    ]"
  >
    <div class="h-footer-wrap-inner">
      <div
        class="nav-item relative"
        v-for="(item, index) in navList"
        :key="'s_' + index"
        v-exposure="{ eid: item.eid }"
        :data-id="item.eid"
        @click="toNav(item, index)"
        :class="{
          'super-item': showType === 3 && index === 2,
        }"
      >
        <div class="redPoint" v-if="havePoint && getNavType(item.jump) === 4"></div>
        <div class="redPoint" v-if="showRedDot && getNavType(item.jump) === 5"></div>
        <div
          class="firstWithdrawTis-wrap"
          @click="clickBubble"
          v-if="getNavType(item.jump) === 3 && showFirstWithdrawTis"
        >
          <div class="text1">{{ $t("Datalang.Home_Please_withdraw") }}</div>
          <div class="bg"></div>
          <div class="triangle"></div>
        </div>
        <img
          class="nav-icon"
          :class="{
            'animation-div': getCurrNavIndex === index,
            swing: havePoint && getNavType(item.jump) === 4 && getCurrNavIndex !== index,
          }"
          v-show="getCurrNavIndex === index && item.languages?.selectIcon"
          :src="$utils.returnImgUrl(item.languages?.selectIcon)"
          alt
        />
        <img
          class="nav-icon"
          :class="{
            'animation-div': getCurrNavIndex === index,
            swing: havePoint && getNavType(item.jump) === 4 && getCurrNavIndex !== index,
          }"
          v-show="getCurrNavIndex !== index && item.languages?.icon"
          :src="$utils.returnImgUrl(item.languages?.icon)"
          alt
        />
        <img
          class="finger-img"
          v-if="havePoint && getNavType(item.jump) === 4 && showFinger"
          :src="require('@/lobby_common/assets/finger.png')"
          alt=""
        />
        <span
          class="nav-name"
          :class="{
            current: getCurrNavIndex === index,
          }"
          >{{ item.languages?.name }}</span
        >
      </div>
    </div>

    <div
      class="download-drawer-entry"
      v-if="isShowDrawerEntry"
      v-show="tooltipVisible"
      @click.stop="handleDrawerEntryClick"
    >
      <span class="icon-wrap">
        <!-- <i class="iconfont el-icon-plus" /> -->
      </span>
      <!-- <el-tooltip
        v-if="tooltipVisible"
        ref="tooltipRef"
        :value="isShowTip && tooltipVisible"
        :manual="true"
        :teleported="false"
        :popper-options="{ strategy: 'fixed' }"
        :open-delay="800"
        placement="top"
        popper-class="registerTip zIndex1900"
      >
        <div class="text" slot="content">
          {{ getBtnTip }}
          <img class="icon" :src="require(`@/lobby_common/assets/activity/gif.png`)" />
        </div>
        <span class="guide-text">{{ $t("Datalang.Save_the_web") }}&nbsp;</span>
      </el-tooltip> -->
      <div class="custom-tooltips" v-if="tooltipVisible && isShowTip">
        <div class="text">
          {{ getBtnTip }}
        </div>
        <img class="icon" :src="require(`@/lobby_common/assets/activity/gif.png`)" />
      </div>
      <span class="guide-text">{{ $t("Datalang.Save_the_web") }}&nbsp;</span>
      <i class="iconfont el-icon-close" style="font-weight: 600" @click.self="handleCloseDrawerEntry" />
    </div>
    <DownloadDrawer
      :visible="drawerVisible"
      :pwaIcon="pwaIcon"
      :systemCheck="systemCheck()"
      @close="handleCloseDrawer"
    />
  </div>
</template>

<script>
// import charge from "@/assets/img/charge.png";
import i18n from "@/lobby_common/locale/index";
import Bus from "@/lobby_common/utils/bus.js";
import menu1 from "@/assets/new/menu1.png";
import menu2 from "@/assets/new/menu2.png";
import home1 from "@/assets/new/home1.png";
import home2 from "@/assets/new/home2.png";
import activity1 from "@/assets/new/activity1.png";
import activity2 from "@/assets/new/activity2.png";
import promotion1 from "@/assets/new/promotion1.png";
import promotion2 from "@/assets/new/promotion2.png";
import user1 from "@/assets/new/user1.png";
import user2 from "@/assets/new/user2.png";
import { goJoinEvent, showFirstWithdrawDialog } from "@/lobby_common/utils/utils.js";
import { mapActions, mapGetters } from "vuex";
import DownloadDrawer from "@/lobby_common/components/downloadDrawer/index.vue";
import { dynamicCreateManifest } from "@/lobby_common/utils/dynamicCreateManifest";
import { debounce } from "@/lobby_common/utils/index.js";
import { getBottomNavigationTemplate } from "@/lobby_common/api/basic_gen";
import { setLocalStorage } from "@/lobby_common/utils/auth.js";
import telegramUtil from "@/lobby_common/utils/telegramUtil.js";
import { getActivityDetail } from "@/lobby_common/api/activity_gen.js";
import { divideAccuracy } from "@/lobby_common/utils/utils.js";
import { getCacheData } from "@/lobby_common/utils/index";
export default {
  name: "h-footer",
  components: {
    DownloadDrawer,
  },
  data: () => ({
    divideAccuracy,
    hasActivityType: false,
    rewardInfo: {},
    showFinger: false,
    currOpt: {},
    showEnter: false,
    curKey: 0,
    isShowDrawerEntry: false,
    drawerVisible: false,
    pwaIcon: "",
    navList: [],
    showType: 1,
    oldIndex: "",
    typeMap: {
      JUMP_FUNCTION_TYPE_ACCUMULATED_BOX: { path: "/user/hDistribution", queryName: "index", queryValue: 4 },
      JUMP_FUNCTION_TYPE_REWARD_BOX: { path: "/user/hDistribution", queryName: "index", queryValue: 3 },
      JUMP_FUNCTION_TYPE_WALLET: { path: "/user/hWallet" },
      JUMP_FUNCTION_TYPE_ACTIVITY_CENTER: { path: "/hEvents", queryName: "tab", queryValue: 2 },
      JUMP_FUNCTION_TYPE_REWARD: { path: "/hEvents", queryName: "tab", queryValue: 1 },
      JUMP_FUNCTION_TYPE_TASK_CENTER: { path: "/hEvents", queryName: "tab", queryValue: 3 },
      JUMP_FUNCTION_TYPE_VIP_LEVEL: { path: "/user/hVip" },
      JUMP_FUNCTION_TYPE_NOTICE: { path: "/user/hNoticeCenter" },
      JUMP_FUNCTION_TYPE_PERSONAL_CENTER: { path: "/userCenter" },
      JUMP_FUNCTION_TYPE_PROMOTION: { path: "/user/hDistribution" },
      JUMP_FUNCTION_TYPE_MAIL: { path: "/user/hNoticeCenter" },
      JUMP_FUNCTION_TYPE_MESSAGE_CENTER: { path: "/user/hNoticeCenter" },
      JUMP_FUNCTION_TYPE_TRADE_RECORD: { path: "/user/hWalletRecord" },
      JUMP_FUNCTION_TYPE_GAME_RECORD: { path: "/user/hGameRecord" },
      JUMP_FUNCTION_TYPE_HISTORY: { path: "/history" },
      JUMP_FUNCTION_TYPE_COLLECTION: { path: "/history" },
      JUMP_FUNCTION_TYPE_CODE_RANK: { path: "/rankPage" },
      JUMP_FUNCTION_TYPE_HOMEPAGE: { path: "/home" },
    },
    // lastClickIndex: -1,
    scrollTimer: null,
    isShowTip: false,
    tooltipVisible: true,
    redDot: false,
  }),
  async mounted() {
    const packageConfig = this.$store.getters.getPacketConfig?.site || {};
    dynamicCreateManifest(packageConfig);
    this.pwaIcon = packageConfig.desktopSmallIcon;
    this.bootStatus = packageConfig.desktopSwitch === "ROW_STATUS_ENABLE";
    const terminaltype = localStorage.getItem("terminaltype") || "normal";
    if (this.systemCheck() === "ios" && !navigator.standalone) {
      this.isShowDrawerEntry =
        this.bootStatus && !localStorage.getItem("drawerClosed") && terminaltype === "normal" && !this.isTgApp;
    }

    if (this.systemCheck() === "android" && !window.matchMedia("(display-mode: standalone)").matches) {
      this.isShowDrawerEntry =
        this.bootStatus && !localStorage.getItem("drawerClosed") && terminaltype === "normal" && !this.isTgApp;
    }
    this.showFinger = !localStorage.getItem("showFinger");
    // window.addEventListener('resize', this.handleScrollOrResize, true);
    // window.addEventListener('scroll', this.handleScrollOrResize, true);
    // // ✅ 添加 visualViewport 监听
    // if (window.visualViewport) {
    //   window.visualViewport.addEventListener('resize', this.handleScrollOrResize);
    //   window.visualViewport.addEventListener('scroll', this.handleScrollOrResize);
    // }
  },
  // beforeUnmount() {
  //   window.removeEventListener('resize', this.handleScrollOrResize, true);
  //   window.removeEventListener('scroll', this.handleScrollOrResize, true);
  //   if (window.visualViewport) {
  //     window.visualViewport.removeEventListener('resize', this.handleScrollOrResize);
  //     window.visualViewport.removeEventListener('scroll', this.handleScrollOrResize);
  //   }
  // },
  created() {
    this.getNavList();
  },
  computed: {
    ...mapGetters(["menuIsShow", "getCurrNavIndex", "getOldNavIndex"]),
    firstWithdrawHint() {
      return this.$store.getters.getFirstWithdrawHint || {};
    },
    // 开启首提并满足条件
    showFirstWithdrawTis() {
      const data = this.firstWithdrawHint;
      return (
        data.isFirstWithdraw === "STATUS_BOOL_TRUE" &&
        data.isSatisfy === "STATUS_BOOL_TRUE" &&
        Number(data.firstWithdrawAmount) &&
        !this.userData.isWithdraw &&
        !data.bubble
      );
    },
    isLogin() {
      return this.$store.getters.login;
    },
    taskDotCount() {
      return this.$store.getters.getTaskDot;
    },
    getPacketConfig() {
      return this.$store.getters.getPacketConfig?.appConfig || {};
    },
    userData() {
      return this.$store.getters.user || {};
    },
    taskDotUrl() {
      return this.$store.getters.getPacketConfig?.appConfig.task_center_tip_url || "";
    },
    taken() {
      return this.$store.getters.taken;
    },
    navBnts() {
      const arr = [
        {
          key: 7,
          icon1: menu1,
          icon2: menu2,
          label: i18n.tc("Datalang.lobbies_menu"),
          width: "25px",
          path: "",
          button: true,
          eventName: "click_menu",
        },
        {
          key: 1,
          icon1: activity1,
          icon2: activity2,
          label: i18n.tc("Datalang.newly_bonus"),
          width: "25px",
          path: "/hEvents?tab=1",
          eventName: "click_activity",
        },
        {
          key: 0,
          icon1: home1,
          icon2: home2,
          label: i18n.tc("Datalang.LowH5_BTM_casino"),
          width: "25px",
          path: "/home",
          eventName: "click_home",
        },
        {
          key: 2,
          icon1: promotion1,
          icon2: promotion2,
          // label: i18n.tc("Datalang.LowH5_BTM_promotshortja"),
          label: i18n.tc("Datalang.Invite_BTM_sharetoearn"),
          width: "25px",
          path: "/user/hDistribution",
          eventName: "click_invite",
        },

        {
          key: 4,
          icon1: user1,
          icon2: user2,
          label: i18n.tc("Datalang.LowH5_BTM_My"),
          width: "25px",
          path: "/userCenter",
          eventName: "click_account",
        },
      ];
      return arr.filter((i) => !i.hide);
    },
    havePoint() {
      const allPoint = this.$store.getters.getAllPoint;
      // 开关是否开启
      const isOpen = this.$store?.getters?.getPacketConfig?.packetInfo?.baseInfo?.userOnboarding === "STATUS_BOOL_TRUE";
      return isOpen && allPoint.includes("JUMP_FUNCTION_TYPE_REWARD");
    },
    appSid() {
      return this.$store.getters.getPacketConfig?.appConfig?.sid;
    },
    useraccuracy() {
      return this.userData.accuracy;
    },
    userCoinSymbol() {
      return this.userData.coinSymbol;
    },
    getBtnTip() {
      return `${this.$t("Datalang.Invite_TITLE_reward")} ${this.userCoinSymbol} ${divideAccuracy(
        this.rewardInfo.rewardValue,
        this.useraccuracy
      )}`;
    },
    hasNewNotice() {
      return this.$store.getters.getNewNotice;
    },
    showRedDot() {
      return this.isLogin && (this.redDot || this.hasNewNotice);
    },
    // isShowTip() {
    //   return !!this.getBtnTip && this.hasActivityType && !!this.taken
    // },
  },
  watch: {
    "$route.params": {
      handler: function () {
        this.pathChange();
      },
      deep: true,
      immediate: true,
    },
    isLogin: {
      handler: function () {
        this.getUserFirstWithdrawHintFun(this.getPacketConfig.coinCode);
      },
      immediate: true,
    },
    menuIsShow: {
      handler: function (val) {
        if (val) {
        } else {
          this.$store.commit("setCurrNavIndex", this.getOldNavIndex);
        }
      },
      deep: true,
      // immediate: true,
    },
  },
  methods: {
    ...mapActions(["setMenuBar"]),
    handleScrollOrResize() {
      // 滚动立即隐藏，防止抖动
      if (this.tooltipVisible) {
        this.tooltipVisible = false;
      }

      // 滚动停止 300ms 后再显示
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        // 再等一帧确保视觉稳定
        requestAnimationFrame(() => {
          this.tooltipVisible = true;
          this.$nextTick(() => {
            this.$refs.tooltipRef?.updatePopper?.();
          });
        });
      }, 300);
    },
    pathChange() {
      console.log(this.$route.query);
      this.navList?.map((v, i) => {
        const item = this.typeMap[v.jump.functionType];
        if (
          item?.path?.includes(this.$route.path) &&
          (!item.queryName || (item.queryName && item.queryValue == this.$route.query[item.queryName]))
        ) {
          this.$store.commit("setCurrNavIndex", i);
          this.$store.commit("setOldNavIndex", i);
        }
      });
    },
    getNavType(jump) {
      // 首页
      if (jump?.type === "Jump_TYPE_FUNCTION" && jump?.functionType === "JUMP_FUNCTION_TYPE_HOMEPAGE") {
        return 1;
      }
      // 菜单
      if (jump?.type === "Jump_TYPE_FUNCTION" && jump?.functionType === "JUMP_FUNCTION_TYPE_MENU") {
        return 2;
      }
      // 个人中心
      if (jump?.type === "Jump_TYPE_FUNCTION" && jump?.functionType === "JUMP_FUNCTION_TYPE_PERSONAL_CENTER") {
        return 3;
      }
      // 奖金入口 活动中心
      if (
        jump?.type === "Jump_TYPE_FUNCTION" &&
        (jump?.functionType === "JUMP_FUNCTION_TYPE_REWARD" ||
          jump?.functionType === "JUMP_FUNCTION_TYPE_ACTIVITY_CENTER")
      ) {
        return 4;
      }
      // 邮箱入口
      if (
        jump?.type === "Jump_TYPE_FUNCTION" &&
        (jump?.functionType === "JUMP_FUNCTION_TYPE_MESSAGE_CENTER" || jump?.functionType === "JUMP_FUNCTION_TYPE_MAIL")
      ) {
        return 5;
      }
      return "";
    },
    async getData() {
      const bottomNavigation = getCacheData("bottomNavigation");
      if (bottomNavigation) {
        return {
          code: 0,
          data: bottomNavigation,
        };
      }
      return getBottomNavigationTemplate({});
    },
    async getNavList() {
      const { code, data } = await this.getData();
      if (code === 0) {
        const items = data?.items || [];
        this.navList = items.map((item, i) => {
          return {
            ...item,
            eid: `101_29_0_${i}`,
          };
        });
        this.showType = data?.showType || 1;
        this.pathChange();
      }
      const activityTypes = this.$store.getters.getAllEnableFeature?.activityTypes || [];
      if (activityTypes && activityTypes.length) {
        this.getActivityInfo();
      } else {
        setTimeout(async () => {
          this.getActivityInfo();
        }, 2000);
      }
    },
    async getActivityInfo() {
      const activityTypes = this.$store.getters.getAllEnableFeature?.activityTypes || [];
      this.hasActivityType = activityTypes.includes("ActivityTypeDownload");
      if (this.hasActivityType) {
        const res = await getActivityDetail({
          appSid: this.appSid,
          activityType: "ActivityTypeDownload", // ActivityTypeDownload
        });
        if (res.code === 0) {
          const data = res.data || {};
          this.rewardInfo = data.activity?.rewardInfo ? JSON.parse(data.activity?.rewardInfo) : {};
        }
        this.isShowTip = this.hasActivityType && !!this.taken;
      }
    },
    // 点击气泡后不展示
    clickBubble() {
      this.$store.commit("setFirstWithdrawHint", { bubble: true });
    },
    // 首提
    getUserFirstWithdrawHintFun: debounce(async function (coinCode) {
      this.$store.dispatch("getUserFirstWithdrawHintAction", { coinCode });
    }, 100),
    // toGame(opt) {
    //   // console.log(opt, "opt=======opt");
    //   this.$PayGame(opt.path, opt.gid, opt.bid, opt.id);
    // },
    encodeBase64(str) {
      return window.btoa(unescape(encodeURIComponent(str)));
    },

    async toNav(item, index) {
      // this.$router.push({
      //   path: "/video",
      //   query: { id: this.encodeBase64("https://www.duboku.online/") },
      // });
      // return false;
      console.log(item, this.getNavType(item.jump));
      this.$store.commit("setCurrNavIndex", index);
      // 如果走首提引导，则不跳转
      let tabJump = true;
      if (this.lastClickIndex !== index) {
        // 如果点击的是同一个菜单不计数
        if (!window.clickTabCount) {
          window.clickTabCount = 1;
        } else {
          window.clickTabCount++;
          if (window.clickTabCount >= 3) {
            window.clickTabCount = 0;
            tabJump = await showFirstWithdrawDialog("Switch");
          }
        }
      }
      this.lastClickIndex = index;
      console.log("clickTabCount", window.clickTabCount);
      if (!tabJump || !item?.jump) return;
      if (!item?.jump) return;
      if (item?.jump?.functionType === "JUMP_FUNCTION_TYPE_REWARD") {
        localStorage.setItem("showFinger", true);
        this.showFinger = false;
      }

      this.$eventPost("h5_click_navigation", {
        navigation_id: item.jump?.functionType || "",
        navigation_name: item.languages.name || "",
        jump_value: item.jump || {},
        SubH5NavigationLocation: index + "",
      });
      this.$eventPost("click", {
        eid: item.eid,
        navigation_id: item.jump?.functionType || "",
        navigation_name: item.languages.name || "",
        jump_value: item.jump || {},
        time: Date.now(),
      });
      if (this.getNavType(item.jump) !== 2) {
        this.$store.commit("setOldNavIndex", index);
        this.menuIsShow && this.setMenuBar(false);
      }
      goJoinEvent(item.jump);
      if (this.getNavType(item.jump) === 2) {
        if (this.menuIsShow) {
          telegramUtil.showBackButton();
          telegramUtil.initBackButton(() => {
            this.setMenuBar(false);
            if (this.$route.meta.hideTGBack) {
              telegramUtil.hideBackButton();
            }
          });
        } else if (this.$route.meta.hideTGBack) {
          telegramUtil.hideBackButton();
          telegramUtil.initBackButton();
        }
      }
    },
    changeEnter(val) {
      // console.log("123321", val);
      this.showEnter = val;
    },
    toLink(opt) {
      opt.eventName && this.$eventPost(opt.eventName);
      if (opt.button) {
        // 点击菜单
        if (this.menuIsShow) {
        } else {
          this.curKey = opt.key;
        }
        this.setMenuBar(!this.menuIsShow);
        return;
      }
      // 未登录点击奖金
      if (opt.key === 1 && !this.$store.getters.taken) {
        this.$Bus.$emit("showLogin", { tab: "Login" });
        return;
      }
      // 隐藏菜单
      this.setMenuBar(false);
      this.curKey = opt.key;
      if (this.curKey === 5 && opt.path === "treasureBox") {
        goJoinEvent({
          jump_type: 2,
          jump_value: 64,
        });
        return;
      }
      if (opt.path === "service") {
        Bus.$emit("goKehu");
      } else {
        this.$router.push(opt.path || "/");
      }
    },
    handleDrawerEntryClick() {
      this.$eventPost("Desktop_Click");
      this.drawerVisible = true;
    },
    handleCloseDrawerEntry() {
      this.$eventPost("Desktop_Close");
      this.isShowDrawerEntry = false;
      localStorage.setItem("drawerClosed", true);
    },
    systemCheck() {
      const u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // 安卓机！
      const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端.
      if (isAndroid) {
        return "android";
      }
      if (isIOS) {
        return "ios";
      }
    },
    handleCloseDrawer() {
      this.drawerVisible = false;
      this.isShowDrawerEntry = false;
      localStorage.setItem("drawerClosed", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-tooltips {
  position: absolute;
  bottom: 36px;
  line-height: 28px;
  padding: 0 25px 0 10px;
  display: flex;
  border-radius: var(--radius-200);
  color: var(--font-color-200);
  background: var(--password-400);
  .text {
    white-space: nowrap;
  }
  .icon {
    position: absolute;
    right: -16px;
    top: 50%;
    transform: translateY(-50%);
  }
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -4px; // 距离父元素  底部
    width: 0;
    height: 0;
    border-width: 6px 6px 0 6px; // 上、右、下、左 边宽
    border-style: solid;
    border-color: var(--password-400) transparent transparent transparent;
    pointer-events: none;
  }
}
.h-footer-wrap {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1002;
  width: 100%;
  background: var(--background-1700);
  padding-top: 3px;
  padding-bottom: calc(env(safe-area-inset-bottom) + var(--android-safe-bottom, 0px));
  &-inner {
    height: 55px;
    display: flex;
    text-align: center;
    justify-content: space-around;
    align-items: center;
    box-sizing: border-box;
  }

  // &.fromTG {

  // }

  &.type1 {
    .nav-item {
      .nav-name {
        margin-top: 2px;
      }
    }
    &.type3 {
      background-image: url("~@/assets/home/bottom_bg.webp");
      background-size: 100% 100%;
      .nav-item {
        justify-content: end;
        padding-bottom: 15px;
      }
    }
  }
  &.type2 {
    .nav-item {
      .nav-icon {
        width: 40px;
      }
      .nav-name {
        position: absolute;
        overflow: auto;
        margin: auto;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .nav-item {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    .nav-icon {
      width: 25px;
      display: block;
    }
    &.super-item {
      .nav-icon {
        width: 80%;
        margin-bottom: 10px;
      }
    }
    .firstWithdrawTis-wrap {
      position: absolute;
      bottom: 54px;
      right: 0;
      width: 130px;
      font-size: 14px;
      line-height: 18px;
      padding: 5px 10px;
      box-sizing: border-box;
      color: var(--font-color-200);
      z-index: 9;
      .triangle {
        display: block;
        position: absolute;
        bottom: -6px;
        right: 30px;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid var(--background-1400);
        opacity: 0.8;
      }
      .text1 {
        width: 100%;
        position: relative;
        z-index: 1;
        text-wrap: wrap;
        word-break: break-word;
      }
      .bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: var(--background-1400);
        opacity: 0.8;
        border-radius: 10px;
      }
    }

    .nav-name {
      font-size: 12px;
      color: var(--font-color-400);
    }

    .nav-name.current {
      font-size: 12px;
      color: var(--font-color-500);
    }
  }
}

.animation-div {
  // position: relative;
  // transform: scale(1);
  // -webkit-transform: scale(1);
  // animation: a_scale1 0.5s; // 一次动画
  // -webkit-animation: a_scale1 0.5s;
  // animation-fill-mode: forwards;
  // -webkit-animation-fill-mode: forwards;
}

.finger-img {
  position: absolute;
  bottom: 47px;
  transform: translateX(-50%);
  left: 50%;
  animation: fingerAnimation 1s linear infinite;
}
.type3 {
  .finger-img {
    bottom: 60px;
  }
}
.super-item {
  .finger-img {
    bottom: 100px;
  }
}

@keyframes fingerAnimation {
  0% {
    transform: translateY(-10px) translateX(-50%);
  }

  50% {
    transform: translateY(0) translateX(-50%);
  }

  100% {
    transform: translateY(-10px) translateX(-50%);
  }
}

// 缩放动画
@keyframes a_scale1 {
  from {
    transform: scale(1);
    -webkit-transform: scale(1);
  }

  to {
    transform: scale(1.2);
    -webkit-transform: scale(1.2);
  }
}
.download-drawer-entry {
  position: fixed;
  opacity: 0.85;
  left: 50%;
  transform: translate(-50%, 0%);
  bottom: 80px;
  max-width: 80%;
  height: 32px;
  color: var(--font-color-900);
  background: var(--background-700);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  // overflow: hidden;
  box-sizing: border-box;
  border-radius: 16px;
  font-size: 14px;
  .icon-wrap {
    border: 1px solid var(--border-color-100);
    border-radius: 4px;
    display: flex;
    align-items: center;
    .iconfont.el-icon-plus {
      font-size: 20px;
    }
  }

  .iconfont.el-icon-circle-close {
    font-size: 24px;
  }
}
.redPoint {
  background-color: var(--tips-100);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  position: absolute;
  left: 45px;
  top: 0px;
  z-index: 9;
}
.type3 {
  .redPoint {
    top: 10px;
  }
}
.super-item {
  .redPoint {
    transform: translateY(-30px);
    left: unset;
  }
}
.redPoint:after {
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  left: 50%;
  top: 50%;
  margin-top: -4px;
  margin-left: -4px;
  background-color: var(--tips-100);
  -webkit-animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes ping {
  75% {
    -webkit-transform: scale(2.5);
    -ms-transform: scale(2.5);
    transform: scale(2.5);
    opacity: 0.4;
  }
  100% {
    -webkit-transform: scale(2.5);
    -ms-transform: scale(2.5);
    transform: scale(2.5);
    opacity: 0;
  }
}
.swing {
  animation: swingAnimation 3.5s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes swingAnimation {
  0% {
    -webkit-transform: rotate(-15deg) scale(1.3);
    transform: rotate(-15deg) scale(1.3);
  }
  2% {
    -webkit-transform: rotate(15deg) scale(1.3);
    transform: rotate(15deg) scale(1.3);
  }
  4% {
    -webkit-transform: rotate(-15deg) scale(1.3);
    transform: rotate(-15deg) scale(1.3);
  }
  6% {
    -webkit-transform: rotate(15deg) scale(1.3);
    transform: rotate(15deg) scale(1.3);
  }
  8% {
    -webkit-transform: rotate(-15deg) scale(1.3);
    transform: rotate(-15deg) scale(1.3);
  }
  10% {
    -webkit-transform: rotate(15deg) scale(1.3);
    transform: rotate(15deg) scale(1.3);
  }
  11% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
</style>
